import React, { useRef, useState, useEffect } from "react"
import { LandWrapper } from "./style"
const LandComponent = ({
  transform,
  children,
  position,
  slideIndex,
  handleSlideSelection,
}) => {
  const [active, setActive] = useState(false)
  const landRef = useRef(null)

  useEffect(() => {
    const target = landRef.current
    const parent = target.parentNode
    const totalElements = parent && parent.children && parent.children.length

    if (target && parent && totalElements) {
      if (slideIndex === position) {
        console.log("target:", target)
        console.log("parent:", parent)
        parent.append(target)
        setTimeout(() => {
          setActive(true)
        }, 50)
      } else {
        setActive(false)
        setTimeout(() => {
          if (position >= totalElements - 1) {
            parent.append(target)
          } else {
            parent.insertBefore(target, parent.children[position])
          }
        }, 300)
      }
    }
  }, [slideIndex])

  const handleLandClick = () => {
    handleSlideSelection(position)
  }

  return (
    <LandWrapper
      onClick={() => handleLandClick()}
      active={active}
      className={active && "active"}
      transform={transform}
      ref={landRef}
    >
      {children}
    </LandWrapper>
  )
}

export default LandComponent
